import { useTranslation } from 'react-i18next'
import {
  isRouteErrorResponse,
  useRouteError,
  useRouteLoaderData
} from 'react-router-dom'

import {
  Column,
  Container,
  EmptyScreen,
  EmptyState,
  ExpiringCertificatesWidget,
  Row
} from '@cdab/scania/qpr/components'
import { useCssVariableBreakpoint } from '@cdab/scania/qpr/hooks'

import { TdsIcon } from '@scania/tegel-react'
import type { DashboardLoaderData } from './dashboard'
import { StyledColumn } from './dashboard'

export function ExpiringCertificates() {
  const { t } = useTranslation('dashboard')
  const { dealers } = useRouteLoaderData('dashboard') as DashboardLoaderData
  const isLg = useCssVariableBreakpoint('--tds-grid-lg')

  if (dealers.length > 0) {
    return (
      <StyledColumn width={12} lg={6} fullHeight padding={isLg}>
        <ExpiringCertificatesWidget dealers={dealers} />
      </StyledColumn>
    )
  }

  return (
    <EmptyScreen.CenteredWrapper>
      <EmptyScreen
        icon={<TdsIcon name='document_check' size='lg' />}
        title={t('no-expiring-certificates-title', {
          ns: 'dashboard'
        })}
        description={t('no-expiring-certificates-description')}
      />
    </EmptyScreen.CenteredWrapper>
  )
}

export function ErrorBoundary() {
  const { t } = useTranslation(['errors', 'common'])
  const isLg = useCssVariableBreakpoint('--tds-grid-lg')
  const error = useRouteError()

  if (isRouteErrorResponse(error)) {
    return (
      <Container
        fluid='normal'
        paddingOnColumns={!isLg}
        paddingOnContainer={!isLg}
      >
        <Row>
          <Column width={12} padding={isLg}>
            <EmptyState
              title={t('something-bad')}
              description={t('talk-to-admin')}
            />
          </Column>
        </Row>
      </Container>
    )
  }

  // rethrow to let the parent error boundary handle it
  // when it's not a special case for this route
  throw error
}
